







































































































































































































































































































































































































































interface ChargeInfo {
    monthlyCharge: number;
    annualCharge: number;
    chargeMethod: number;
    startPeriod?: string | number;
}
import { Component, Vue } from "vue-property-decorator";
import LetterTabVue from "../components/LetterTab.vue";
import ThDropdownVue from "../components/ThDropdown.vue";
import ViewAccountBookVue from "../components/AccountBookList/ViewAccountBook.vue";
import ChargeSetVue from "../components/Charge/ChargeSet.vue";
import ChargeInfoVue from "../components/Charge/ChargeInfo.vue";
import ChargeRecordVue from "../components/Charge/ChargeRecord.vue";
import AllUserTreeVue, { UserTree } from "@/components/User/AllUserTree.vue";
import version from "@/version";


import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["account"]),
    components: {
        "letter-tab": LetterTabVue,
        "th-dropdown": ThDropdownVue,
        "view-book": ViewAccountBookVue,
        "change-set": ChargeSetVue,
        "charge-info": ChargeInfoVue,
        "charge-record": ChargeRecordVue,
        "user-tree": AllUserTreeVue
    },
})
export default class Charge extends Vue {
    tableData: Charge.Charge[] = [];
    currentPage: number = 1;
    pageSize: number = 13;
    searchKey: string = "";
    totalElements: number = 0;
    monthlyChargeMin: string | number = "";
    monthlyChargeMax: string | number = "";
    monthlyPeriod = "";
    annualPeriodMin: string | number = "";
    annualPeriodMax: string | number = "";
    annualPeriod = "";

    // 修改页数SIze
    changeSize(size: number) {
        this.pageSize = size;
	    this.fetchData();
    }

    dropList: DataTable.DropItem[] = [
        {
            text: "全部",
            id: 0,
        },
        {
            text: "欠收",
            id: -1,
        },
        {
            text: "预收",
            id: 1,
        },
    ];
	accounterNo: string = this.$store.state.account.no;
    accounterName: string = "所属人姓名";
	// 打开tree
	isTree: boolean = false;
	openTree() {
		this.isTree = !this.isTree;
	}
	// 展开tree时,暂存tmp,以便关闭dialog时,直接从tmp展示tree
	tmp: UserTree | null = null;
	treeExpand(data: UserTree) {
		this.tmp = data;
	}
	// 点击tree中的名字(node)
	isScope: boolean = false;
	handleNodeClick(data: Account) {
		this.isScope = true;
		if (data.name) this.accounterName = data.name;
		this.currentPage = 1;
		this.$store.dispatch("clearSearchKey");
		this.accounterNo = data.no;
		this.fetchData();
		this.isTree = false;
	}
	// 关闭tree
	closeTree() {
		this.isTree = false;
	}
    dropStatus = 0;
    chargeInfo: ChargeInfo | null = null;
    changp() {
        console.log(this.monthlyPeriod);
    }
    mounted() {
        this.fetchData();
    }
    resetFilter() {
        this.dropStatus = 0;
        this.monthlyPeriod = "";
        this.annualPeriod = "";
        this.monthlyChargeMin = "";
        this.monthlyChargeMax = "";
        this.annualPeriodMin = "";
        this.annualPeriodMax = "";
    }
    confirmFilter() {
        this.currentPage = 1;
        this.fetchData();
        this.filterVisible = false;
    }
    async exportCharge() {
		this.$utils.sendToElectron("download", `${Vue.axios.defaults.baseURL}export/charge?accounterNo=${this.accounterNo}&annualPeriodMax=${this.annualPeriodMax}&annualPeriodMin=${this.annualPeriodMin}&monthlyChargeMax=${this.monthlyChargeMax}&monthlyChargeMin=${this.monthlyChargeMin}&searchKey=${this.searchKey}&state=${this.dropStatus}&monthlyPeriod=${this.monthlyPeriod?this.$utils.simpleDateFormat(new Date(this.monthlyPeriod), "m"):""}&annualPeriod=${this.annualPeriod?this.$utils.simpleDateFormat(new Date(this.annualPeriod), "m"):""}&query=${this.$store.state.searchKey}&version=${version}&token=${this.$store.state.account.token}`);
	}
    // 获取表格数据
    fetchData() {
        Vue.axios
            .post(
                `charge/list?page=${this.currentPage - 1}&size=${
                    this.pageSize
                }`,
                {
                    accounterNo: this.accounterNo,
                    searchKey: this.searchKey,
                    state: this.dropStatus,
                    query: this.$store.state.searchKey,
                    monthlyPeriod: this.monthlyPeriod?this.$utils.simpleDateFormat(
                        new Date(this.monthlyPeriod),
                        "m"
                    ):"",
                    annualPeriod: this.annualPeriod?this.$utils.simpleDateFormat(
                        new Date(this.annualPeriod),
                        "m"
                    ):"",
                    monthlyChargeMin: this.monthlyChargeMin,
                    monthlyChargeMax: this.monthlyChargeMax,
                    annualPeriodMin: this.annualPeriodMin,
                    annualPeriodMax: this.annualPeriodMax,
                }
            )
            .then((res) => {
                this.tableData = res.data.content;
                this.totalElements = res.data.totalElements;
            });
    }

    // 分页
    handleCurrentChange(val: number) {
        this.currentPage = val;
        this.fetchData();
    }

    // 修改客户
    showInfo: boolean = false;
    bookData: AccountBookList.AccountBook | null = null;
    accountModify(data: AccountBookList.AccountBook) {
        Vue.axios.get(`accountbooks/${data.id}`).then((res) => {
            this.bookData = res.data;
            this.showInfo = true;
        });
    }
    closeInfo() {
        this.showInfo = false;
    }
    infoSuccess() {
        this.fetchData();
        this.showInfo = false;
    }

    // 收费设置模态框
    chargeData: Charge.Charge | null = null;
    showSettings: boolean = false;
    closeSet() {
        this.showSettings = false;
    }
    setSuccess(val: ChargeInfo) {
        this.fetchData();
        this.showSettings = false;
        if (this.chargeData) {
            let chargeMethod = val.chargeMethod;
            this.chargeData.monthlyCharge = val.monthlyCharge;
            this.chargeData.annualCharge = val.annualCharge;
            this.chargeData.chargeMethod = chargeMethod.toString();
            this.chargeData.chargeStartPeriod = <string>val.startPeriod;
        }
    }
    chargeSet(data: Charge.Charge) {
        this.chargeData = data;
        this.showSettings = true;
    }
    //收费设置开关
    showSettingsFn(data: Charge.Charge) {
        this.chargeData = data;
        this.showSettings = true;
    }

    // 收费模态框
    showChargeInfo: boolean = false;
    isChargeInfo(data: Charge.Charge) {
        this.chargeData = data;
        this.showChargeInfo = true;
    }
    closeChargeInfo() {
        this.showChargeInfo = false;
    }
    chargeInfoSuccess() {
        this.fetchData();
        this.showChargeInfo = false;
    }

    // 详情模态框
    showRecord: boolean = false;
    isRecord(data: Charge.Charge) {
        this.chargeData = data;
        this.showRecord = true;
    }
    closeRecord() {
        this.showRecord = false;
        this.fetchData();
    }
    recordSuccess() {
        this.showRecord = false;
        this.fetchData();
    }

    // 筛选
    filterVisible = false;
}
